<template lang="pug">
div.row
    div.col-sm-12.voided-box.text-center(v-if="isVoid")
        small.block {{ pgsql_transaction.void_details.void_reason }}
        small
            | Voided by&nbsp;
            span._500 {{ pgsql_transaction.void_details.voided_by.staff_name }}
            | &nbsp;on {{ receiptDateFormat(pgsql_transaction.receipt_date) }}

</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transactionPostgres', ['pgsql_transaction', 'isVoid']),
    },
};
</script>
